import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import {
  approveWebsiteUser,
  approveWebsiteUserData,
  disapproveWebsiteUser,
  disapproveWebsiteUserData,
  fetchWebsiteUser, setWebsiteProperty
} from "../../actions";
import { selectWebsiteUser } from "../../selectors";
import { REQUEST_APPROVE_WEBSITE_USER, REQUEST_DISAPPROVE_WEBSITE_USER, REQUEST_WEBSITE_USER } from "../../constants";
import { BaseComponent } from "../../../../components/BaseComponent";
import { Loader } from "react-feather";
import { Content } from "../../../../components/Content";
import { HBox, VBox } from "../../../../components/Box";
import { UserPropertiesEditor } from "../_UserPropertiesEditor";
import { selectWorks } from "../../../Api/selectors";
import { Check, ChevronRight, Left, Times } from "../../../../components/Icon";
import { Button } from "../../../../components/Buttons";
import { Property } from "../../../Vehicles/components/VehiclePropertiesEditor";
import { PageHeader } from "../../../../components/PageHeader";
import {Modal, ModalControls} from "../../../../components/Modal";
import {FormField, FormFields} from "../../../../components/FormFields";
import {Input} from "../../../../components/Input";
import {Checkbox} from "../../../../components/Checkbox";

const Container = styled.div`
  .content {
    display: inline-block;
    width: 100%;
  }
`;

const PropsSectionContainer = styled.div`
  .user-property-row {
    > div {
      width: 200px;

      &:last-child {
        width: 100px;
        text-align: right;
      }
    }

    > .dirty {
      color: red;
    }

    > .clean {
      color: black;
    }
  }
`;

const ApprovementSectionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

/* eslint-disable react/prefer-stateless-function */
class WebsiteUserDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetchWebsiteUser();
  }

  get user() {
    return this.props.user;
  }

  get userProperties() {
    let props = (this.user.properties ?? []).map(p => {
      return { name: p?.name?.name, value: p?.value };
    });
    props.unshift({ name: 'email_address', value: this.user.email_address });

    return props;
  }

  renderPropsSection() {
    return (
      <PropsSectionContainer>
        <VBox>{this.userProperties.map(p => this.renderProperty(p))}</VBox>
      </PropsSectionContainer>
    );
  }

  getTemporaryProp(propName, originValue) {
    let isDirty = false;
    if (!this.user.user_website_data_evaluate || !this.user.temporaryProperties) return '';
    if (!Array.isArray(this.user.temporaryProperties)) return '';
    const foundProp = this.user.temporaryProperties.find(p => p.name === propName);
    let value = '';
    if (foundProp) {
      value = foundProp.value;
      isDirty = true;
    }
    if (value === originValue) {
      value = '';
      isDirty = false;
    }


    return { value, isDirty };
  }

  renderProperty(property) {
    const value = property.value;
    const tmpProp = this.getTemporaryProp(property.name, property.value);
    const originValueClass = tmpProp.isDirty ? 'dirty' : 'clean';

    return (
      <Property key={`${property.name}`} data-name={property.name} onClick={this.onClickEditProperty.bind(this)}>
        <HBox className="user-property-row">
          <div className="name">{property.name}</div>
          <div className={originValueClass}>{value === 1 ? <Check /> : value === 0 ? <Times /> : value}</div>
          <div className="name">{tmpProp.value}</div>
        </HBox>
      </Property>
    );
  }

  onClickEditProperty(evt) {
    const name = evt.currentTarget.getAttribute('data-name');
    const value = this.userProperties.find(p => p.name === name)?.value;
    this.setState({ edit: { name, value } });
  }

  save() {
    const userId = this.user.id;
    const { name, value } = this.state.edit;
    this.props.setWebsiteProperty(userId, name, value, () => {
      this.setState({ edit: null });
    });
  }

  reset() {
    this.setState({ edit: null });
  }

  onInputChange(evt) {
    let value = evt.target.value;

    this.setState((prev, props) => {
      return { ...prev, edit: { ...prev.edit, value } };
    });
  }

  renderEditModal() {
    if (!this.state.edit) return '';
    const property = this.state.edit;
    return (
      <Modal key='edit' onClose={this.reset.bind(this)} title={this.lbl('user.property.edit')}>
        <FormFields>
          <h1>{property.name}</h1>
          <FormField>
            {this.renderInput(property)}
            {/*<Input value={property.value} name={property.name} onChange={this.onInputChange.bind(this)} />*/}
          </FormField>
        </FormFields>
        <ModalControls>
          <Button primary onClick={this.save.bind(this)}>
            Save
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderInput(property) {
    const booleanFields = [
      'financial_price_nett_excl_vat_bpm',
      'financial_price_gross_incl_btw_bpm',
      'financial_price_b2b_incl_vat_btpm',
      'financial_price_b2c_Bruto',
      'financial_price_b2c',
      'newsletters',
    ];

    const stringFields = [
      'default_language',
      'country_code',
      'company_name',
      'company_place',
      'name',
      'surname',
    ];

    if (booleanFields.includes(property.name)) {
      return (
        <HBox left>
          <Checkbox
            onChange={() => {
              this.setState((prev, props) => {
                return { ...prev, edit: { ...prev.edit, value: 1 } };
              });
            }}
            checked={this.state.edit.value === 1}
            className="rounded"
            rounded
          >
            <strong className="radio-label">{this.lbl('yes')}</strong>
          </Checkbox>

          <Checkbox
            onChange={() => {
              this.setState((prev, props) => {
                return { ...prev, edit: { ...prev.edit, value: 0 } };
              });
            }}
            className="rounded"
            checked={this.state.edit.value === 0}
            rounded
          >
            <strong className="radio-label">{this.lbl('no')}</strong>
          </Checkbox>
        </HBox>
      );
    }

    if (stringFields.includes(property.name)) {
      return <Input value={property.value} name={property.name} onChange={this.onInputChange.bind(this)} />
    }

    return <Input disabled={true} value={property.value} name={property.name} onChange={this.onInputChange.bind(this)} />
  }

  renderUserApprovementSection() {
    if (!this.user.evaluate_for_website) return '';

    return (
      <ApprovementSectionContainer>
        <Property>
          <div>{this.lbl('website.users.approveMsg')}</div>
        </Property>
        <Button small onClick={this.props.approveWebsiteUser.bind(this)}>
          <Check />
        </Button>
        <Button small onClick={this.props.disapproveWebsiteUser.bind(this)}>
          <Times />
        </Button>
      </ApprovementSectionContainer>
    );
  }

  renderDataApprovementSection() {
    if (!this.user.user_website_data_evaluate) return '';

    return (
      <ApprovementSectionContainer>
        <Property>
          <div>{this.lbl('website.users.approveDataMsg')}</div>
        </Property>
        <Button small onClick={this.props.approveWebsiteUserData.bind(this)}>
          <Check />
        </Button>
        <Button small onClick={this.props.disapproveWebsiteUserData.bind(this)}>
          <Times />
        </Button>
      </ApprovementSectionContainer>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (!this.user) return 'x';
    return (
      <Container>
        <PageHeader
          title={
            <div onClick={this.tofn(`/website-users`)}>
              <Left />
              {this.lbl('leftBar.website_users')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('leftBar.website_users')}
              <ChevronRight />
              {this.user.name}
            </>
          }
        />
        <Content className="content">
          <VBox>
            <HBox>
              {this.renderPropsSection()}
            </HBox>
          </VBox>
        </Content>
        {this.renderUserApprovementSection()}
        {this.renderDataApprovementSection()}
        {this.renderEditModal()}
      </Container>
    );
  }
}

WebsiteUserDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    user: selectWebsiteUser(),
    work: selectWorks([REQUEST_WEBSITE_USER, REQUEST_APPROVE_WEBSITE_USER, REQUEST_DISAPPROVE_WEBSITE_USER]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchWebsiteUser: () => {
      dispatch(fetchWebsiteUser(ownProps.user_id))
    },
    approveWebsiteUser: () => {
      dispatch(approveWebsiteUser(ownProps.user_id))
    },
    disapproveWebsiteUser: () => {
      dispatch(disapproveWebsiteUser(ownProps.user_id))
    },
    approveWebsiteUserData: () => {
      dispatch(approveWebsiteUserData(ownProps.user_id))
    },
    disapproveWebsiteUserData: () => {
      dispatch(disapproveWebsiteUserData(ownProps.user_id))
    },
    setWebsiteProperty: (userId, name, value, callback) => {
      dispatch(setWebsiteProperty(userId, name, value, callback))
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WebsiteUserDetails = compose(
  withConnect,
  withRouter,
)(WebsiteUserDetailsComp);
